import { useTranslation } from 'react-i18next';
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Row, Select, Typography } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { EnrollClassEnum } from "../../../../constants/learing-material";
import { getAllTeacherInstruction } from "../../../../service/test-schedule";
import { filterOption } from "../../../../utils/functionUltils";
interface FormFilterProps {
  handleCloseFilter: () => void
  showFilter: boolean;
  setFilterData: (values: any) => void;
  dataOptions?: any;
}


const FormFilter = (props: FormFilterProps) => {
  const { t } = useTranslation();
  const { showFilter, setFilterData } = props
  const [form] = Form.useForm();
  const { Title } = Typography;
  const { RangePicker } = DatePicker;
  const { courseId } = useParams()
  const [classList, setClassList] = useState<any>([])
  const handleFinish = (values: any) => {
    setFilterData(values)
  };

  useEffect(() => {
    const fetchListTeacher = async () => {
      try {
        const res = await getAllTeacherInstruction(Number(courseId))
        setClassList(res?.data.data.map((it: any) => {
          return {
            ...it,
            value: it.id,
            label: it.name,
          }
        }))
      } catch (error) {

      }
    }
    fetchListTeacher()
  }, [])

  const enrollClassStatus = [
    { value: EnrollClassEnum.NOT_YET_OPEN, label: t("Chưa mở ghi danh", "Chưa mở ghi danh") },
    { value: EnrollClassEnum.ENROLLING, label: t("Đang mở ghi danh", "Đang mở ghi danh") },
    { value: EnrollClassEnum.CLOSED_ENROLLING, label: t("Đóng ghi danh", "Đóng ghi danh") },
    { value: EnrollClassEnum.OPENED, label: t("Đã khai giảng", "Đã khai giảng") },
    { value: EnrollClassEnum.CLOSED, label: t("Đã kết thúc", "Đã kết thúc") },
  ];


  return (
    <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
      <Form form={form} onFinish={handleFinish} layout="vertical">
        <Row gutter={[16, 16]}>

          <Col xs={24} sm={12} md={6}>
            <Title level={5}>{t("Giảng viên", "Giảng viên")}</Title>
            <Form.Item name="lecturer" className="mb-0">
              <Select
                showSearch
                placeholder={t("Chọn giảng viên", "Chọn giảng viên")}
                filterOption={filterOption}
                options={classList}
                mode="multiple"

              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Title level={5}>{t("Trạng thái", "Trạng thái")}</Title>
            <Form.Item name="status" className="mb-0">
              <Select placeholder={t("Trạng thái", "Trạng thái")}
                options={enrollClassStatus}
              />
            </Form.Item>
          </Col>

          <Col
            xl={{ span: 6 }}
            md={{ span: 6 }}
            sm={{ span: 24 }}
            xs={{ span: 24 }}
            style={{ display: "flex", alignItems: "flex-end" }}
          >
            <div className="group-btn--filter gap-16">
              <Button
                className="btn btn-primary search-btn"
                onClick={() => form.submit()}
              >
                <FilterOutlined />
                <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
              </Button>
              <Button
                className="btn btn-outlined clear-filter-btn"
                onClick={() => {
                  form.resetFields();
                  setFilterData({});
                }}
              >
                <DeleteOutlined />
                <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
              </Button>
            </div>
          </Col>
        </Row>

      </Form>
    </div>
  );
};

export default FormFilter;
